import Button from "../Button";
import copy from "copy-to-clipboard";
import { DateTime } from "luxon";
import { toast } from "react-toastify";
import Input from "../Input";
import { Inertia } from "@inertiajs/inertia";
import Label from "../Label";
import { parseDate } from "@/helpers/date";

const TicketCard = ({ status, id, uuid, expired, expiration_at, enabledCancelOrders, enabledRestoreOrders, onSelect, onDeselect, selected, bulkSale }) => {
    const handleCopyUrl = () => {
        const url = route('branch-office.selector') + '/?uuid=' + uuid;
        copy(url);
        toast.success("URL de ticket copiado al portapapeles");
    };

    const onHandleCheckbox = (event) => {
        if (event.target.checked) {
            onSelect(id);
        } else {
            onDeselect(id);
        }
    }

    const AvailabilityText = () => {
        if (status === 'generated') {
            if (expired) {
                return (
                    <p className="font-bold text-yellow-500">Expirado</p>
                )
            } else {
                return (
                    <p className="font-bold text-green-500">Disponible</p>
                )
            }
        }

        // if (status === 'validated') {
        //     return (
        //         <p className="font-bold text-red-500">Validado</p>
        //     )
        // }

        if (status === 'canceled') {
            return (
                <p className="font-bold text-red-500">Anulado</p>
            )
        }

        if (status === 'consumed') {
            return (
                <p className="font-bold text-red-500">Cobrado</p>
            )
        }
    }


    return (
        <div className="flex items-center">
            <div className="flex items-center justify-between bg-white p-4 rounded-xl w-full mr-2">
                <div>
                    <h3>Ticket #{id}</h3>
                    <AvailabilityText />
                </div>
                <div>
                    <p className="text-sm text-gray-500">Válido hasta {DateTime.fromJSDate(parseDate(expiration_at)).setLocale('es').toFormat("dd 'de' MMMM, yyyy")}</p>
                </div>
                <div>
                    {status === 'canceled' && (
                        <Button onClick={() => Inertia.post(route('bulk-sales.bulk-orders.restore', { bulkSale, bulk_order_ids: [id] }))}>Restaurar</Button>
                    )}
                    <Button processing={status === 'canceled'} onClick={handleCopyUrl}>Copiar link</Button>
                </div>
            </div>
            {((enabledCancelOrders && status !== 'canceled') || (enabledRestoreOrders && status === 'canceled')) && (
                <div className="flex items-center gap-2">
                    <Input
                        type="checkbox"
                        checked={selected}
                        handleChange={onHandleCheckbox}
                        id={`ticket-checkbox-select-${id}`}
                    />
                    <Label
                        className="whitespace-nowrap"
                        forInput={`ticket-checkbox-select-${id}`}
                        value={(enabledCancelOrders && 'Anular ticket') || (enabledRestoreOrders && 'Restaurar ticket')}
                    />
                </div>
            )}
        </div>
    );
};

export default TicketCard;
